import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  effect,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IndianNumberPipe } from '../pipes/indian-number.pipe';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
  selector: 'app-common-component-pagination',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIcon,
    MatInputModule,
    NgxMatSelectSearchModule,
    IndianNumberPipe,
  ],
  templateUrl: './common-component-pagination.component.html',
  styleUrls: ['./common-component-pagination.component.scss'],
})
export class CommonPaginationComponent implements OnChanges {
  @Input() totalItems = 10;
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() pageSize = 10;
  @Output() pageChange = new EventEmitter<number>();
  @Output() sizeChange = new EventEmitter<number>();

  customPage = this.currentPage;
  pageOptions = [10, 25, 50, 100];

  constructor() {
    effect(() => this.calculateTotalPages());
  }

  calculateTotalPages(): void {
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    this.currentPage = Math.max(this.currentPage, 1);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['totalItems'] ||
      changes['pageSize'] ||
      changes['currentPage']
    ) {
      this.calculateTotalPages();
    }
  }

  onPageChange(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
    } else {
      this.currentPage = 1;
      this.pageChange.emit(this.currentPage);
    }
  }

  onSizeChange(size: number): void {
    this.pageSize = size;
    this.sizeChange.emit(this.pageSize);
    this.currentPage = 1;
  }

  handleEnter(event): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default behavior
      event.stopPropagation(); // Stop event from bubbling
      this.goToPage();
      // Explicitly remove focus from the input field
      (event.target as HTMLInputElement).blur();
    }
  }

  goToPage(): void {
    let page = this.currentPage;
    if (page < 1 && page > this.totalPages) {
      page = 1;
    }
    this.onPageChange(page);
  }
}
